// @ts-nocheck

import { selectIsBoomPlayable } from '../modules/boom/selectors/runtime.selector';
import { selectIsGRPlayable } from '../modules/gift-race/selectors/specifics/selectGRRuntime';
import { selectIsKLPlayable } from '../modules/koh-lanta/selectors/runtime';
import { type StateType } from '../states';
import { type Selector } from '../types/selectors';
import { getShouldEnlightOperationsDisplay } from '../utils/operations';

import { selectRuntimeLicence } from './runtime/runtimePrimary.selector';
import { selectUserDidReceivedUserData, selectUserPromotionStatus } from './user/userPrimary.selector';

// no-memoize
export const selectShowOperationBanners: Selector<boolean> = (state: StateType) => {
  const licence = selectRuntimeLicence(state);
  const promotionStatus = selectUserPromotionStatus(state);
  const didReceivedUserData = selectUserDidReceivedUserData(state);

  if (licence !== undefined) {
    return getShouldEnlightOperationsDisplay(licence, promotionStatus, didReceivedUserData);
  }

  return false;
};

// no-memoize
export const selectIsAnyOperationRunning: Selector<boolean> = (state: StateType) => {
  const isGRPlayable = selectIsGRPlayable(state);
  const isKLPlayable = selectIsKLPlayable(state);
  const isBoomPlayable = selectIsBoomPlayable(state);

  return isGRPlayable || isKLPlayable || isBoomPlayable;
};
